<template>
  <b-modal size="lg" class="modal-lg modal-game-rule" id="modalGameRule" :no-close-on-backdrop="true" ref="modalGameRule" hide-footer :title="$t('game.add_new_rule')" >
    <b-form class="row game-rule-content">
      <b-col cols="12">
        <div class="form-group row">
          <legend class="col-sm-2 col-form-label text-truncate">{{$t('game.rule_name')}}</legend>
          <div class="col-sm-10">
            <b-form-input
              v-model="item.name"
              :state="!$v.item.name.$invalid"
              :aria-describedby="'name-rule'" 
            />
            <b-form-invalid-feedback id="name-rule">
              {{ $t('message.required_filed') }}
            </b-form-invalid-feedback>
          </div>
        </div>
      </b-col>
      <b-col cols="12">
        <div class="form-group row">
          <div class="col-sm-12">
            <div class="d-flex align-items-center">
              <span class="mr-2" :title="$t('game.grant_point_user')">{{$t('game.grant_point_user')}}</span>
              <c-switch type="icon" variant="success" class="mb-0" v-bind="{on: '\uf00c', off: '\uf00d'}" :pill="true" v-model="item.is_grant_user" :value="true" :uncheckedValue="false"/>
            </div>
            <p class="font-italic mb-0 mt-2">{{$t('game.msg_grant_point_user')}}</p>
          </div>
        </div>
      </b-col>
      <b-col v-if="!item.is_grant_user" cols="12">
        <div class="row">
          <b-col cols="6">
            <div class="form-group row">
              <legend class="col-sm-4 col-form-label text-truncate" :title="$t('game.token_per_order')">{{$t('game.token_per_order')}}</legend>
              <div class="col-sm-8">
                <b-form-input
                  type="number"
                  :min="1"
                  v-model="item.token_per_order"
                  :state="!$v.item.token_per_order.$invalid"
                  :aria-describedby="'token-per-order'" 
                  :class="error.invalidToken && 'is-invalid'"
                />
                <b-form-invalid-feedback v-if="$v.item.token_per_order.$invalid" id="token-per-order">
                  {{ $t('message.required_filed') }}
                </b-form-invalid-feedback>
                <p class="error-text" v-if="!$v.item.token_per_order.$invalid && error.invalidToken">{{error.invalidToken}}</p>
              </div>
            </div>
          </b-col>
          <b-col cols="6">
            <div class="form-group row">
              <legend class="col-sm-4 col-form-label text-truncate">{{$t('game.min_spend')}}</legend>
              <div class="col-sm-8">
                <b-form-input
                  type="number"
                  :min="1"
                  v-model="item.min_spend"
                  :state="!$v.item.min_spend.$invalid"
                  :aria-describedby="'min-spend'" 
                  :class="error.invalidMinSpend && 'is-invalid'"
                />
                <b-form-invalid-feedback v-if="$v.item.min_spend.$invalid" id="min-spend">
                  {{ $t('message.required_filed') }}
                </b-form-invalid-feedback>
                <p class="error-text" v-if="!$v.item.min_spend.$invalid && error.invalidMinSpend">{{error.invalidMinSpend}}</p>
              </div>
            </div>
          </b-col>
        </div>
      </b-col>
      <b-col v-else cols="12">
        <div class="row">
          <b-col cols="12">
            <div class="form-group row">
              <legend class="col-sm-2 col-form-label text-truncate" :title="$t('game.token')">{{$t('game.token')}}</legend>
              <div class="col-sm-10">
                <b-form-input
                  type="number"
                  :min="1"
                  v-model="item.token_per_order"
                  :state="!$v.item.token_per_order.$invalid"
                  :aria-describedby="'token-per-order'" 
                  :class="error.invalidToken && 'is-invalid'"
                />
                <b-form-invalid-feedback v-if="$v.item.token_per_order.$invalid" id="token-per-order">
                  {{ $t('message.required_filed') }}
                </b-form-invalid-feedback>
                <p class="error-text" v-if="!$v.item.token_per_order.$invalid && error.invalidToken">{{error.invalidToken}}</p>
              </div>
            </div>
          </b-col>
        </div>
      </b-col>
      <b-col v-if="!item.is_grant_user" cols="12">
        <div class="row">
          <b-col cols="6">
            <div class="form-group row">
              <legend class="col-sm-4 col-form-label text-truncate">{{$t('game.sale_chanel')}}</legend>
              <div class="col-sm-8">
                <b-form-select
                  v-model="item.sales_channel"
                  v-bind:value="item.sales_channel"
                  :options="sale_channels[$session.get('lang')]"
                  v-bind:placeholder="$t('common.sale_chanel')">
                </b-form-select>
              </div>
            </div>
          </b-col>
          <b-col cols="6">
            <div class="form-group row">
              <legend class="col-sm-4 col-form-label text-truncate">{{$t('game.order_type')}}</legend>
              <div class="col-sm-8">
                <b-form-select
                  v-model="item.order_type"
                  v-bind:value="item.order_type"
                  :options="order_types[$session.get('lang')]"
                  v-bind:placeholder="$t('order-phil.order_type')">
                </b-form-select>
              </div>
            </div>
          </b-col>
        </div>
      </b-col>
      <!-- End of Days of Week -->
      <hr class="w-100 mb-4">
      <b-col cols="6">
        <div class="form-group row">
          <legend class="col-sm-4 col-form-label text-truncate">{{$t('game.start')}}</legend>
          <div class="col-sm-8">
            <date-picker-input
              className="form-control float-left border-radius-4px"
              name="date"
              type="date"
              v-model="item.startRecur"
              :lang="$session.get('lang')"
              :hasPicker="true"
              formatInput="YYYY-MM-DD"
              formatOutput="YYYY-MM-DD"
              :shortMinute="true"
              :change="(e) => item.startRecur = e"
              :errorClass="$v.item.startRecur.$invalid || error.invalidDate ? 'error' : ''"
            />
            <b-form-invalid-feedback :id="'startRecur-feedback'">
              {{ $t('message.required_filed') }}
            </b-form-invalid-feedback>
          </div>
        </div>
        <div class="form-group row">
          <legend class="col-sm-4 col-form-label text-truncate">{{$t('game.from')}}</legend>
          <div class="col-sm-8">
            <date-picker-input
              className="form-control float-left"
              name="date"
              type="time"
              v-model="item.startTime"
              :hasPicker="true"
              formatInput="HH:mm"
              formatOutput="HH:mm"
              :change="(e) => item.startTime = e"
              :errorClass="$v.item.startTime.$invalid || error.invalidTime ? 'error' : ''"
            />
            <b-form-invalid-feedback :id="'startTime-feedback'">
              {{ $t('message.required_filed') }}
            </b-form-invalid-feedback>
          </div>
        </div>
      </b-col>
      <b-col cols="6">
        <div class="form-group row">
          <legend class="col-sm-4 col-form-label text-truncate">{{$t('game.end')}}</legend>
          <div class="col-sm-8">
            <date-picker-input
              className="form-control float-left border-radius-4px"
              name="date"
              type="date"
              v-model="item.endRecur"
              :lang="$session.get('lang')"
              :hasPicker="true"
              formatInput="YYYY-MM-DD"
              formatOutput="YYYY-MM-DD"
              :shortMinute="true"
              :change="(e) => item.endRecur = e"
              :errorClass="$v.item.endRecur.$invalid || error.invalidDate ? 'error' : ''"
            />
            <b-form-invalid-feedback :id="'endRecur-feedback'">
              {{ $t('message.required_filed') }}
            </b-form-invalid-feedback>
            <p class="error-text mb-0" v-if="error.invalidDate">{{error.invalidDate}}</p>
          </div>
        </div>
        <div class="form-group row">
          <legend class="col-sm-4 col-form-label text-truncate">{{$t('game.to')}}</legend>
          <div class="col-sm-8">
            <date-picker-input
              className="form-control float-left"
              name="date"
              type="time"
              v-model="item.endTime"
              :hasPicker="true"
              :disabled="item.is_grant_user"
              formatInput="HH:mm"
              formatOutput="HH:mm"
              :change="(e) => item.endTime = e"
              :errorClass="$v.item.endTime.$invalid || error.invalidTime ? 'error' : ''"
            />
            <b-form-invalid-feedback :id="'endTime-feedback'">
              {{ $t('message.required_filed') }}
            </b-form-invalid-feedback>
             <p class="error-text mb-0" v-if="error.invalidTime">{{error.invalidTime}}</p>
          </div>
        </div>
      </b-col>
      <b-col cols="12">
        <div class="form-group row mt-3">
          <legend class="col-sm-2 col-form-label text-truncate">{{$t('game.repeat')}}</legend>
          <div class="col-sm-10">
            <div class="d-flex align-items-center">
              <span class="weekly-box mr-2 text-center" style="width: 40px;"
              v-for="day in daysOfWeek"
              :key="`${day.key}-${item.is_grant_user}`"
              :class="item.daysOfWeek && item.daysOfWeek.includes(day.key) && day.active === 1 ? 'active-day' : ''"
              @click="() => selectDaysOfWeek(day.key, day.active)">{{day.title}}</span>
            </div>
          </div>
        </div>
      </b-col>
      <b-col cols="12">
        <div class="form-group row mt-3">
          <legend class="col-sm-2 col-form-label text-truncate">{{$t('game.color')}}</legend>
          <div class="col-sm-10">
            <div class="d-flex align-items-center">
              <span class="mr-2 text-center cursor-pointer" v-for="color in colors" :key="color" @click="() => selectColor(color)">
                <i :class="`fa fa-fw ${item.backgroundColor === color ? 'fa-check-circle' : 'fa-circle'}`" :style="`color: ${color}; font-size: 28px`"></i>
              </span>
            </div>
          </div>
        </div>
      </b-col>
      <b-col cols="12">
        <div class="alert alert-danger mb-0" v-if="error.duplicatedItem">
          <p class="mb-2">{{ $t('duplicated_game_rule') + ' ' }} <b>{{ error.duplicatedItem.name }}</b></p>
          <ul>
            <li class="mt-2 mb-2">{{ $t('game.sale_chanel') }}: <b>{{ getSalesChanelName(error.duplicatedItem.sales_channel) }}</b></li>
            <li class="mt-2 mb-2">{{ $t('game.order_type') }}: <b>{{ getOrderTypeName(error.duplicatedItem.order_type) }}</b></li>
            <li class="mt-2 mb-2">{{ $t('game.from') }}: <b>{{ error.duplicatedItem.startRecur + ' ' + error.duplicatedItem.startTime }}</b></li>
            <li class="mt-2 mb-2">{{ $t('game.to') }}: <b>{{ error.duplicatedItem.endRecur + ' ' + error.duplicatedItem.endTime }}</b></li>
          </ul>
        </div>
      </b-col>
      <hr class="w-100">
    </b-form>
    <div class="d-flex align-items-center w-100">
      <button type="button" @click.stop="() => deleteEventData()" v-if="item.id" class="btn btn-danger border-radius-4px mr-auto">{{$t('common.delete')}}</button>
      <button type="button" @click.stop="() => closeModalGameRule()" class="btn border-radius-4px ml-auto">{{$t('common.cancel')}}</button>
      <button type="button" @click.stop="() => saveData()" class="btn btn-primary border-radius-4px ml-2" style="background:#0086FF !important; background-color: #0086FF !important; float: right;">{{$t('common.ok')}}</button>
    </div>
  </b-modal>
</template>

<script>
import DatePickerInput from '@/components/Partials/DatePickerInput'
import cSwitch from '@/components/Switch'
import {validationMixin} from 'vuelidate'
import {required} from 'vuelidate/lib/validators'

export default {
  components: {
    DatePickerInput,
    cSwitch
  },
  data: function() {
    return {
      dataEvents: [],
      order_types: [],
      sale_channels: [],
      daysOfWeek: [
        {
          key: 0,
          title: 'S',
          value: 'sun',
          active: 1
        },
        {
          key: 1,
          title: 'M',
          value: 'mon',
          active: 1
        },
        {
          key: 2,
          title: 'T',
          value: 'tue',
          active: 1
        },
        {
          key: 3,
          title: 'W',
          value: 'wed',
          active: 1
        },
        {
          key: 4,
          title: 'T',
          value: 'thu',
          active: 1
        },
        {
          key: 5,
          title: 'F',
          value:'fri',
          active: 1
        },
        {
          key: 6,
          title: 'S',
          value: 'sat',
          active: 1
        }
      ],
      item: {
        name: '',
        is_grant_user: true,
        token_per_order: 0,
        sales_channel: '',
        min_spend: 0,
        order_type: '',
        startTime: '',
        startRecur: '',
        endTime: '',
        endRecur: '',
        backgroundColor: '#0091ff',
        daysOfWeek: []
      },
      colors: ['#0091ff', '#6c757d', '#28a745', '#dc3545', '#ffc107', '#17a2b8', '#343a40'],
      error: {
        invalidDate: '',
        invalidTime: '',
        invalidToken: '',
        invalidMinSpend: '',
        duplicatedItem: null
      },
    }
  },
  mixins: [
    validationMixin
  ],
  validations: {
    item: {
      name: {
        required
      },
      token_per_order: {
        required
      },
      min_spend: {
        required
      },
      startRecur: {
        required
      },
      endRecur: {
        required
      },
      startTime: {
        required
      },
      endTime: {
        required
      }
    }
  },
  watch: {
    'item.is_grant_user'  (newValue, oldValue) {
      if (this.item.is_grant_user) {
        const arrs = this.item.startTime.split(':')
        const time = Number(arrs[0]) + 1
        this.item.endTime = time === 24 ? '23:59:59' : `${time < 10 ? '0' + time : time}:${arrs[1]}:${arrs[2]}`
      }
    },
    'item.token_per_order' (newValue, oldValue) {
      this.checkValidation()
    },
    'item.min_spend' (newValue, oldValue) {
      this.checkValidation()
    },
    'item.startRecur' (newValue, oldValue) {
      this.checkValidation()
      this.checkRepeatData()
    },
    'item.endRecur' (newValue, oldValue) {
      this.checkValidation()
      this.checkRepeatData()
    },
    'item.startTime' (newValue, oldValue) {
      if (this.item.is_grant_user) {
        const arrs = this.item.startTime.split(':')
        const time = Number(arrs[0]) + 1
        this.item.endTime = time === 24 ? '23:59:59' : `${time < 10 ? '0' + time : time}:${arrs[1]}:${arrs[2]}`
      }
      this.checkValidation()
    },
    'item.endTime' (newValue, oldValue) {
      this.checkValidation()
    }
  },
  created () {
    let langs = Object.keys(this.$i18n.messages);
    for (let l in langs) {
      this.order_types[langs[l]] = [
        {text: this.$t('common.all', langs[l]), value: 'A'},
        {text: this.$t('common.delivery', langs[l]), value: 'D'},
        {text: this.$t('common.takeaway', langs[l]), value: 'C'},
        {text: this.$t('common.restaurant', langs[l]), value: 'R'}
      ]
      this.sale_channels[langs[l]] = [
        {text: this.$t('common.all', langs[l]), value: 'A'},
        {text: this.$t('common.web', langs[l]), value: 'Web'},
        {text: this.$t('common.mobile_app', langs[l]), value: 'App'},
      ]
    }
  },
  mounted () {
    this.$root.$on('showModalGameRule', (item, date, default_conditions, dataEvents) => {
      this.error = {
        invalidDate: '',
        invalidTime: '',
        invalidToken: '',
        invalidMinSpend: '',
        duplicatedItem: null
      };
      this.dataEvents = dataEvents
      if (item) {
        this.item = JSON.parse(JSON.stringify(item))
      } else {
        const timezone = this.$const.CLIENT_TIMEZONE[this.$store.getters.config.base.id] || this.$moment.tz.guess()
        let dateTime = null
        if (date) {
          dateTime = this.convertDateToDateTime(date)
        }
        const startDate = dateTime ? dateTime.date : this.convertDateTimeToLocal(null, timezone)
        this.item = {
          id: null,
          is_grant_user: true,
          name: 'Game rule',
          token_per_order: default_conditions && default_conditions.token_per_order,
          min_spend: default_conditions && default_conditions.min_spend,
          sales_channel: 'A',
          order_type: 'A',
          startTime: dateTime ? dateTime.time : '08:00:00',
          startRecur: startDate,
          endTime: '22:00:00',
          endRecur: dateTime ? dateTime.date : this.convertDateTimeToLocal(null, timezone, 30),
          special_dates: [],
          backgroundColor: '#0091ff',
          daysOfWeek: [this.getDaysOfWeek(new Date(startDate), 0)]
        }
      }
      if(this.$refs.modalGameRule) {
        this.$refs.modalGameRule.show()
      }
    })
    this.$root.$on('closeModalGameRule', () => {
      this.closeModalGameRule()
    })
  },
  destroyed () {
    this.$root.$off('showModalGameRule')
    this.$root.$off('closeModalGameRule')
  },
  methods: {
    getSalesChanelName (value) {
      const data = this.sale_channels[this.$session.get('lang')]
      const arrs = data.filter(element => {
        return element.value === value
      })
      if (arrs.length > 0) {
        return arrs[0].text
      }
    },
    getOrderTypeName (value) {
      const data = this.order_types[this.$session.get('lang')]
      const arrs = data.filter(element => {
        return element.value === value
      })
      if (arrs.length > 0) {
        return arrs[0].text
      }
    },
    checkDuplicatedTime () {
      let check = true;
      let duplicatedItem = null
      if (this.dataEvents.length > 0) {
        for (let i = 0; i < this.dataEvents.length; i++) {
          const element = this.dataEvents[i];
          const item = this.item
          if (i === this.dataEvents.length - 1) {
            if ((element.sales_channel === 'A' && element.order_type === 'A') 
              || (item.sales_channel === 'A' && item.order_type === 'A') 
              || (element.sales_channel === item.sales_channel && element.order_type === item.order_type)) {
              const specialDates = element.special_dates || []
              const checkSpecialDates = specialDates.includes(item.startRecur)
              const arrsDaysOfWeeks = element.daysOfWeek.filter(arr1Item => item.daysOfWeek.includes(arr1Item))
              if (!checkSpecialDates && arrsDaysOfWeeks.length > 0 && item.id !== element.id && !this.checkStartAndEndCalendar(item, element)) {
                duplicatedItem = element
                check = false
                break
              }
            }
          }
        }
      }
      this.error.duplicatedItem = duplicatedItem
      return check;
    },
    checkRepeatData () {
      const arrsStart = this.item.startRecur.split('-')
      const arrsEnd = this.item.endRecur.split('-')
      const startDate = new Date(Number(arrsStart[0]), Number(arrsStart[1]) - 1, Number(arrsStart[2]))
      startDate.setHours(0);
      startDate.setMinutes(0, 0, 0);
      const endDate = new Date(Number(arrsEnd[0]), Number(arrsEnd[1]) - 1, Number(arrsEnd[2]))
      endDate.setHours(0);
      endDate.setMinutes(0, 0, 0);
      const daysDiff = parseInt(Math.abs(endDate.getTime() - startDate.getTime()) / (24 * 60 * 60 * 1000), 10) + 1
      if (daysDiff < 7) {
        for (let i = 0; i < this.daysOfWeek.length; i++) {
          const element = this.daysOfWeek[i];
          element.active = 0;
          for (let j = 0; j < daysDiff; j++) {
            const dayOfWeek = this.getDaysOfWeek(startDate, j);
            if (element.key === dayOfWeek) {
              element.active = 1
              break
            }
          }
          if (element.active === 0) {
            const index = this.item.daysOfWeek.indexOf(element.key);
            if (index > -1) {
              this.item.daysOfWeek.splice(index, 1);
            }
          }
        }
      } else {
        for (let i = 0; i < this.daysOfWeek.length; i++) {
          const element = this.daysOfWeek[i];
          element.active = 1;
        }
      }
    },
    selectDaysOfWeek(key, active) {
      if (active === 0) {
        return;
      }
      if (this.item.daysOfWeek.includes(key)) {
        if (this.item.daysOfWeek.length === 1) {
          return;
        }
        const index = this.item.daysOfWeek.indexOf(key)
        if (index > -1) {
          this.item.daysOfWeek.splice(index, 1)
        }
      } else {
        this.item.daysOfWeek.push(key)
      }
    },
    selectColor (color) {
      this.item.backgroundColor = color
    },
    checkValidation () {
      let check = true;
      if (this.item.token_per_order <= 0) {
        check = false
        this.error.invalidToken = this.$t('validate_token_per_order')
      } else {
        this.error.invalidToken = ''
      }
      if (this.item.min_spend <= 0) {
        check = false
        this.error.invalidMinSpend = this.$t('validate_min_spend')
      } else {
        this.error.invalidMinSpend = ''
      }
      if (this.item.startRecur > this.item.endRecur) {
        check = false
        this.error.invalidDate = this.$t('invalid_period_time_range')
      } else {
        this.error.invalidDate = ''
      }
      const timezone = this.$const.CLIENT_TIMEZONE[this.$store.getters.config.base.id] || this.$moment.tz.guess()
      if (this.item.startTime > this.item.endTime) {
        check = false
        this.error.invalidTime = this.$t('message.from_to_time_invalid')
      } else if (this.item.endRecur && this.item.endTime && !this.compareDateTimeWithNow(`${this.item.endRecur} ${this.item.endTime}`, timezone)) {
        check = false
        this.error.invalidTime = this.$t('message.to_time_with_now_invalid')
      } else {
        this.error.invalidTime = ''
      }
      return check
    },
    saveData() {
      if(!this.checkValidation() || !this.checkDuplicatedTime()) {
        return
      }
      const days_of_week_values = []
      this.daysOfWeek.forEach(element => {
        if (element.active && this.item.daysOfWeek.includes(element.key)) {
          days_of_week_values.push({
            day: element.value,
            opening: this.item.startTime.length < 6 ? `${this.item.startTime}:00` : this.item.startTime,
            closing: this.item.endTime.length < 6 ? `${this.item.endTime}:00` : this.item.endTime,
            active: 1,
            start_date: this.item.startRecur,
            end_date: this.item.endRecur,
          })
        }
      });
      this.closeModalGameRule()
      this.$emit('updateGameRuleEvent', this.item, days_of_week_values)
    },
    closeModalGameRule () {
      this.$refs.modalGameRule.hide()
    },
    deleteEventData() {
      this.closeModalGameRule()
      this.$emit('deleteGameRuleEvent', this.item)
    }
  }
}
</script>

<style scoped>
  .weekly-box {
    padding: 8px 10px;
    margin: 0px 2px;
    background: #d2d2d2;
    color: #fff;
    font-weight: bold;
    font-size: 18px;
    border-radius: 3px;
    cursor: pointer;
  }
  .active-day {
    color: #fff;
    background: #0086FF;
  }
  .error-text {
    width: 100%;
    margin-top: 0.25rem;
    font-size: 80%;
    color: #f86c6b;
  }
</style>


// WEBPACK FOOTER //
// src/views/admin/game/ModalGameRule.vue